// extracted by mini-css-extract-plugin
var _1 = "Group_card__8325d";
var _2 = "Group_group__47452";
var _3 = "Group_label__29f80";
var _4 = "Group_mask__63a20";
var _5 = "Group_placeholder__56673";
export { _1 as "card", _2 as "group", _3 as "label", _4 as "mask", _5 as "placeholder" }
